/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdc_Field_AvailableInputs */

const vi_pdc_field_available = /** @type {(inputs: Pdc_Field_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tồn khả dụng`)
};

/**

* @param {Pdc_Field_AvailableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pdc_field_available = /** @type {((inputs?: Pdc_Field_AvailableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdc_Field_AvailableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pdc_field_available(inputs)
});